export default __webpack_public_path__ + "img/41a2ff960cc7ca573e8453024c6b9856.svg";